import React from "react";

import SliderMini from "components/Inputs/Slider/SliderMini";

import styles from "./style.module.css";

export default class ChooseProcessLimitMini extends React.PureComponent {
  state = {
    showSlider: true
  };

  handleNoConstraints() {
    const { updateProcessLimit, total } = this.props;
    const { showSlider } = this.state;

    updateProcessLimit(total);
    return this.setState({ showSlider: !showSlider });
  }

  render() {
    const {
      id,
      total,
      processLimit,
      processLimitPct,
      trueAction,
      options,
      targeted,
      isShow,
      timePeriod,
      updateProcessLimit,
      updateTimePeriod
    } = this.props;
    const { showSlider } = this.state;

    if (processLimit === undefined) {
      return <div />;
    }

    return (
      <div className={styles.sliders}>
        {showSlider && (
          <div style={{ width: "100%" }} id="processSlider">
            <div className={styles.slideMsg}>
              {"My new processing capacity is: "}
              <span className={styles.slideSpan}>{(processLimitPct * 100).toFixed(2) + "%"}</span>
            </div>
            <SliderMini
              min={0}
              max={total}
              value={processLimit}
              inputType={"int"}
              onChange={(val) => updateProcessLimit(val)}
              className={styles.sliderHolderMini}
              endLabel={timePeriod ? "Transactions per " + timePeriod : "Transactions"}
              isWideLabel
              style={{ paddingTop: "0px" }}
              isMini
            />
          </div>
        )}
      </div>
    );
  }
}
